<template>
    <div class="faq-editor">
      <h3>Éditeur de FAQ</h3>
      <div v-for="(faq, index) in localfieldData.faqItems" :key="index" class="faq-item">
        <div class="form-group">
          <label for="question-fr-{{ index }}">Question Français</label>
          <input
            v-model="faq.question_fr"
            :id="'question-' + index"
            type="text"
            placeholder="Entrez la question"
          />
        </div>
        <div class="form-group">
          <label for="answer-fr-{{ index }}">Réponse Français</label>
          <textarea
            v-model="faq.answer_fr"
            :id="'answer-' + index"
            placeholder="Entrez la réponse"
          ></textarea>
        </div>
        <div class="form-group">
          <label for="question-fr-{{ index }}">Question Anglais</label>
          <input
            v-model="faq.question_en"
            :id="'question-' + index"
            type="text"
            placeholder="Entrez la question"
          />
        </div>
        <div class="form-group">
          <label for="answer-fr-{{ index }}">Réponse Anglais</label>
          <textarea
            v-model="faq.answer_en"
            :id="'answer-' + index"
            placeholder="Entrez la réponse"
          ></textarea>
        </div>
        <button @click="removeFaq(index)" class="btn-remove">Supprimer la FAQ</button>
      </div>
  
      <button @click="addFaq" class="btn-add">Ajouter une FAQ</button>
  
      <div class="form-actions">
        <button @click="saveChanges" class="btn-save">Enregistrer</button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "FaqEditor",
    props: {
      fieldData: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        // Crée une copie locale de fieldData
        localfieldData: JSON.parse(JSON.stringify(this.fieldData))
      };
    },
    methods: {
      addFaq() {
        this.localfieldData.push({
          question: "",
          answer: ""
        });
      },
      removeFaq(index) {
        this.localfieldData.splice(index, 1);
      },
      saveChanges() {
        // Émettre un événement pour envoyer les modifications au parent
        this.$emit("update-faq", this.localfieldData);
      }
    }
  };
  </script>
  
  <style scoped>
  .faq-editor {
    padding: 20px;
    background-color: #f9f9f9;
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
  
  .faq-item {
    margin-bottom: 20px;
  }
  
  .form-group {
    margin-bottom: 15px;
  }
  
  input,
  textarea {
    width: 100%;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  
  textarea {
    height: 100px;
  }
  
  button {
    padding: 10px 15px;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .btn-add {
    background-color: #28a745;
    color: white;
  }
  
  .btn-remove {
    background-color: #dc3545;
    color: white;
  }
  
  .btn-save {
    background-color: #007bff;
    color: white;
  }
  
  button:hover {
    opacity: 0.8;
  }
  </style>
  